export class SelectFilterElement<V, E> {
    constructor(id: string|number, value: V, element: E) {
        this.id = id;
        this.value = value;
        this.element = element;
    }

    id: string|number;
    value: V;
    element: E;
}


export interface NewItem<V, E> {
    create();
    onDidDismiss: <T = any>() => Promise<SelectFilterElement<V,E>>;
}
